import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {getToken} from "./Connector/Connector"
//REDUX SETUP
import { OpenUrl } from "./services/sso";
import { Provider } from "react-redux";
import { fetchLanguages } from "../src/Connector/Connector";
import configureStore from "./configureStore";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

// const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = configureStore();

//OpenUrl("https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=https://www.textunited.com/json-free-translator/?checkOnly=Y");
getToken().then((response) => {
      sessionStorage.setItem("refresh_token", response.data.refreshToken);
      sessionStorage.setItem("token", response.data.accessToken);
    }
);

store.dispatch(fetchLanguages());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <ToastContainer autoClose={false} transition={Bounce} style={{ width: "550px" }} />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
